import { createSlice } from "@reduxjs/toolkit";

import { masterCuisinesAPI } from "../../../api/master";
import { sliceHandler } from "../utils";

const getmasterCuisines = createSlice(
    sliceHandler({
        name: 'getmasterCuisines',
        action: 'getmasterCuisinesSlice',
        success: 'getmasterCuisinesSliceSuccess',
        failure: 'getmasterCuisinesSliceFailure',
        reset: 'getmasterCuisinesSliceReset'
    })
);

const getmasterCuisinesAction: any = getmasterCuisines.actions;
const getmasterCuisinesHandler = () => async (dispatch: any) => {
    try {
        dispatch(getmasterCuisinesAction.getmasterCuisinesSlice());
        const response: any = await masterCuisinesAPI();
        dispatch(getmasterCuisinesAction.getmasterCuisinesSliceSuccess(response));
    } catch (e: any) {
        dispatch(getmasterCuisinesAction.getmasterCuisinesSliceFailure(e?.response?.data));
    }
};

export {
    getmasterCuisinesAction,
    getmasterCuisinesHandler,
}
export default getmasterCuisines.reducer;